import api from './index';

import {
    list_sectors
} from '@/config/endpoints';

export const fetchSectors = async (userGroup) => {
    return api(userGroup)
        .get(list_sectors);
}